<script lang="ts">

    import { Icon } from "sveltestrap";
    import type { Answer, QuestionOption } from "../../global";
    import type { Question } from "../../Model/Question";
    import Watch from "../Watch.svelte";

    export let question: Question;
    export let answer: Answer;

    const checked: string[] = (answer?.value || '').split(',');
    
    function iconName(option: QuestionOption): string  {
        let type = question.type === 'bool' ? 'circle' : 'square';
        if (checked.includes(option.id)) {
            type = `check-${type}`;
        }
        return type;
    }

</script>

<style lang="scss">

    li {
        list-style: none;
    }

</style>

<h6>
    <Watch store={question.name} />
</h6>

<ul>
    <Watch store={question.options.questionOptions} let:value={options}>
        {#each options as option}
            <li>
                <Icon name={iconName(option)} /> <Watch store={option.text} />
            </li>
        {/each}
    </Watch>
</ul>
